// Define messages outside the component if they don't depend on props or state
const defaultMessages = {
  email: {
    id: 'email',
    defaultMessage: 'Email'
  },
  country: {
    id: 'country_code',
    defaultMessage: 'Country'
  },
  rockmanid: {
    id: 'rockman_id',
    defaultMessage: 'Rockman ID'
  },
  serviceid: {
    id: 'service_id',
    defaultMessage: 'Rockman ID'
  },
  required: {
    id: 'required',
    defaultMessage: 'is required'
  },
  cc_number: {
    id: 'cardNumber',
    defaultMessage: 'Credit Card Number'
  },
  cc_holder: {
    id: 'cardHolder',
    defaultMessage: 'Credit Card Holder Name'
  },
  expirationYear: {
    id: 'expYear',
    defaultMessage: 'Expiry Year'
  },
  expirationMonths: {
    id: 'expMonth',
    defaultMessage: 'Expiry Month'
  },
  cvv: {
    id: 'cvv',
    defaultMessage: 'CVV Code'
  },
  invalid: {
    id: 'invalid',
    defaultMessage: 'is invalid'
  },
  cc_expiry: {
    id: 'expDate',
    defaultMessage: 'Expiry Date'
  },
  cc_expiryPlaceholder: {
    id: 'expDatePlaceholder',
    defaultMessage: 'MM/YY'
  },
  cvvPlaceholder: {
    id: 'cvvPlaceholder',
    defaultMessage: 'CVV'
  },
  cc_numberPlaceholder: {
    id: 'cardNumber',
    defaultMessage: 'Credit Card Number'
  },
  fieldRequired: { id: 'fieldRequired', defaultMessage: 'This field is required.' },
  declinedAntiFraud: {
    id: 'declinedAntiFraud',
    defaultMessage: 'Your card could not be processed. Please use another card (error code E1)'
  },
  FraudExtraTry: {
    id: 'FraudExtraTry',
    defaultMessage: 'Your card could not be processed. Please use another card (error code E2)'
  },
  '3dSecureNotEnabled': {
    id: '3dSecureNotEnabled',
    defaultMessage: 'Your card could not be processed. Please use another card (error code E3)'
  }
};

export default defaultMessages;
